import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "colon",
  "use": "colon-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol viewBox=\"0 0 36 36\" id=\"colon\">\n<circle cx=\"18\" cy=\"6\" r=\"5\" />\n<circle cx=\"18\" cy=\"30\" r=\"5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol